// extracted by mini-css-extract-plugin
export var displayNone = "_uj-6";
export var imgContainer = "_uj-2";
export var overflowHidden = "_uj-3";
export var productInfoCardButtonContainer = "_uj-5";
export var productTitleText = "_uj-4";
export var rightArrow = "_uj-1";
export var rightArrowContainer = "_uj-0";